export const BASE_URL_IMAGE = "http://inventcolab.com/mls";
// ------------------- Not Available Image Url -----------------------
export const ImageNotAvailable =
  "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png";
